module.exports = __webpack_public_path__ + "files/40ca250f5ad46502793799ed1dc2eaed.png";